import { gray } from '../../../../utils/constants'

export const container = { border:`1px solid ${gray}`,padding:'15px', marginBottom:'10px' }
export const generatetemplate = { marginLeft:'15px',minHeight:'38px', fontSize:'105%', borderWidth:'2px' }


// WEBPACK FOOTER //
// ./src/containers/event/components/setupComplete/style.js